import React from 'react'
import Layout from './theme/Layout'

export default function Contact() {
  const handleSubmit = e => {
    e.preventDefault()
    // Aquí luego puedes integrar tu envío real (API, mail, etc.)
  }

  return (
    <Layout title="Contacto">
      <section className="py-5 bg-light">
        <div className="container-lg">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-8 text-center">
              <h1 className="h3 fw-bold mb-2">Ponte en contacto</h1>
              <p className="text-muted mb-0">
                ¿Tienes dudas sobre un evento, entradas o colaboraciones?
                Escríbenos y un miembro del equipo se pondrá en contacto contigo.
              </p>
            </div>
          </div>

          <div className="row g-4 justify-content-center">
            {/* Formulario de contacto */}
            <div className="col-lg-7 col-md-8">
              <div className="card border-0 shadow-sm rounded-4">
                <div className="card-body p-4 p-md-5">
                  <h2 className="h5 fw-semibold mb-3">Envíanos un mensaje</h2>
                  <p className="text-muted small mb-4">
                    Completa el formulario y cuéntanos en qué podemos ayudarte.
                  </p>

                  <form id="myForm" onSubmit={handleSubmit} noValidate>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <label
                          htmlFor="name"
                          className="form-label small text-muted mb-1"
                        >
                          Nombre
                        </label>
                        <input
                          id="name"
                          type="text"
                          placeholder="Tu nombre"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>

                      <div className="col-md-6">
                        <label
                          htmlFor="email"
                          className="form-label small text-muted mb-1"
                        >
                          Email
                        </label>
                        <input
                          id="email"
                          type="email"
                          placeholder="tucorreo@ejemplo.com"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label
                          htmlFor="subject"
                          className="form-label small text-muted mb-1"
                        >
                          Asunto
                        </label>
                        <input
                          id="subject"
                          type="text"
                          placeholder="¿Sobre qué trata tu consulta?"
                          className="form-control form-control-lg"
                          required
                        />
                      </div>

                      <div className="col-12">
                        <label
                          htmlFor="body"
                          className="form-label small text-muted mb-1"
                        >
                          Mensaje
                        </label>
                        <textarea
                          id="body"
                          className="form-control"
                          placeholder="Cuéntanos más detalles…"
                          rows={4}
                          required
                        />
                      </div>

                      <div className="col-12 mt-2">
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary btn-lg w-100 d-flex justify-content-center align-items-center gap-2"
                        >
                          <i className="fas fa-paper-plane" />
                          <span>Enviar mensaje</span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* Información de contacto / marcas */}
            <div className="col-lg-4 col-md-8">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                <div className="card-body p-4 d-flex flex-column">
                  <h2 className="h6 fw-semibold mb-3">Información de contacto</h2>

                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2">
                      <div className="me-2">
                        <i className="fas fa-phone-alt text-primary" />
                      </div>
                      <a
                        href="tel:9999999999"
                        className="text-decoration-none text-dark"
                      >
                        9999999999
                      </a>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <div className="me-2">
                        <i className="fas fa-envelope text-primary" />
                      </div>
                      <a
                        href="mailto:INFO@GMAIL.COM"
                        className="text-decoration-none text-dark"
                      >
                        INFO@GMAIL.COM
                      </a>
                    </div>
                  </div>

                  <hr className="my-3" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  )
}
